import React from "react";
import MuiTable from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import RowContext from "./RowContext";

export const Table =
    ({ datasource = [], children, size}) => {

    let headersTemplate = null;
    let bodyTemplate = null;

    React.Children.forEach(
        children,
        (child: any) => {

            if (
                child?.type?.dslType ===
                "headers"
            ) {
                headersTemplate = child;
            }

            if (
                child?.type?.dslType ===
                "body"
            ) {
                bodyTemplate = child;
            }
        }
    );

    return (<TableContainer component={Paper}>
        <MuiTable size={size || 'small'}>

            {/* HEADERS */}
            <TableHead>
                {headersTemplate}
            </TableHead>

            {/* BODY */}
            <TableBody>

                {datasource.map(
                    (row, rowIndex) => (

                        <RowContext.Provider
                            key={rowIndex}
                            value={{
                                row,
                                rowIndex,
                            }}
                        >

                            {bodyTemplate}

                        </RowContext.Provider>
                    )
                )}

            </TableBody>

        </MuiTable>
    </TableContainer>
    );
};

export default Table;
